import React, { useState, useEffect } from "react";
import location from "../icons/location.png";
import back from "../icons/keyboard.png";
import { useNavigate } from "react-router-dom";

const styles = {
    // page shell
    page: { minHeight: "100vh", background: "#F6F8FB", color: "#1A1A1A" },
    body: { padding: 16, maxWidth: 390, margin: "0 auto" },

    /* ===== Header (matches your Figma) ===== */
    headerWrap: { position: "sticky", top: 0, zIndex: 10, background: "#FFF", borderBottom: "1px solid #E5E7EB" },
    headerRow: {
        position: "relative",
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 8px",
    },
    backBtn: {
        width: 30, height: 30, padding: 10,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "transparent", border: "none", cursor: "pointer"
    },
    backIcon: { width: 38, height: 38 },
    title: {
        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
        margin: 0, fontWeight: 500, fontSize: 18, lineHeight: "28px", letterSpacing: 0, textAlign: "center"
    },
    saveBtn: {
        background: "None",
        color: "#1559EA",
        fontWeight: 600,
        fontSize: 14,
        height: 22,
        lineHeight: "22px",
        padding: "0 10px",
        border: "None",
        cursor: "pointer",
        outline: "none",
    },


    /* ===== Section & labels ===== */
    section: { marginTop: 24 },
    sectionTitle: { fontWeight: 600, marginBottom: 12 },

    /* ===== Field rows (shared) ===== */
    fieldLabel: { display: "block", fontSize: 14, fontWeight: 500, marginBottom: 6 },
    inputRow: {
        display: "flex", alignItems: "center", gap: 8,
        border: "1px solid #E5E7EB", background: "#FFF",
        borderRadius: 12, padding: "12px 12px"
    },
    textInput: { flex: 1, outline: "none", border: "none", background: "transparent", fontSize: 14, color: "#1A1A1A" },
    trailingIcon: { width: 24, height: 24, opacity: 0.6 },

    /* ===== Segmented buttons ===== */
    segmentRow: { display: "flex", gap: 8 },
    segment: {
        flex: 1,
        padding: "10px 0",
        borderRadius: 12,
        border: "1px solid #D1D5DB",
        background: "#FFF",
        textAlign: "center",
        cursor: "pointer",
        fontSize: 14,
        fontWeight: 500,

        // Reset browser defaults
        outline: "none",
        boxShadow: "none",
        borderColor: "#D1D5DB",   // force consistent border
        color: "#1A1A1A",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
    },
    segmentActive: {
        background: "#E7F0FF", borderColor: "#1559EA", color: "#1559EA"
    },

    /* ===== Sliders + scale labels ===== */
    slider: { width: "100%" },
    scale: { display: "flex", justifyContent: "space-between", fontSize: 12, color: "#6B7280", marginTop: 6 },

    /* ===== Counters/Toggles ===== */
    rowCard: {
        display: "flex", alignItems: "center", justifyContent: "space-between",
        background: "#FFF", border: "1px solid #E5E7EB", borderRadius: 12, padding: "12px 16px", marginBottom: 12
    },
    counterBtn: {
        width: 32, height: 32, borderRadius: 999, border: "1px solid #D1D5DB",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 18, lineHeight: "18px", cursor: "pointer", userSelect: "none"
    },
    // Track (button)
    toggleTrack: (on) => ({
        position: "relative",
        width: 52,                     // slightly wider for spacing
        height: 28,
        borderRadius: 999,
        background: on ? "#1559EA" : "#E5E7EB",
        transition: "background .15s",
        border: "none",
        outline: "none",
        cursor: "pointer",
        appearance: "none",            // remove default styles
        WebkitAppearance: "none",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.04)", // subtle edge
    }),

    // Thumb (circle)
    toggleThumb: (on) => ({
        position: "absolute",
        top: 3,                        // 28 - 22 = 6 -> 3px top/bottom
        left: on ? 27 : 3,             // 52 - 22 - 3 = 27px
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: "#FFF",
        transition: "left .15s ease",
        boxShadow:
            "0 1px 2px rgba(0,0,0,0.20), 0 0 0 1px rgba(0,0,0,0.06)", // iOS-like
    }),

    /* ===== Chips / vibe ===== */
    chipInput: {
        width: "100%", border: "1px solid #E5E7EB", background: "#FFF",
        borderRadius: 12, padding: "12px 12px", fontSize: 14, outline: "none"
    },
    chipWrap: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 },
    chip: { display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 10px", background: "#E5ECF6", borderRadius: 999, fontSize: 13 },
    chipX: { border: "none", background: "transparent", cursor: "pointer", color: "#4B5563" },

    /* ===== Amenity grid ===== */
    grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 },

    subLabel: { fontSize: 13, color: "#4B5563", marginTop: 12, marginBotton: 12 },

    amenitiesGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 12 },

    pillBtn: {
        padding: "12px 10px",
        border: "1px solid #E5E7EB",
        background: "#FFF",
        borderRadius: 12,
        fontSize: 14,
        cursor: "pointer",
        transition: "all .15s ease",
    },
    pillBtnSelected: {
        background: "var(--colors-blue-100, #DCEBFE)",
        border: "1px solid var(--colors-blue-500, #3479E9)",
        color: "#1A1A1A",
        fontWeight: "inherit", // or just remove this line entirely
    },
    backToTop: {
        width: "100%", padding: "12px 0", borderRadius: 12,
        background: "#FFF", border: "1px solid #E5E7EB", cursor: "pointer", marginTop: 30
    }
};

function readOnboardingPrefs() {
    // preferred unified object if you later set it in step 3
    try {
        const unified = JSON.parse(localStorage.getItem("onboarding_prefs") || "null");
        if (unified && typeof unified === "object") return unified;
    } catch (_) { }

    // backward-compat with what your steps already store today
    const familySize = localStorage.getItem("familySize") || "";
    const accommodation = localStorage.getItem("accommodation") || "";
    const destination =
        localStorage.getItem("destination") || // if you decide to store it in step 3
        localStorage.getItem("prefillDestination") || // fallback used by your overlay flow
        "";

    return { familySize, accommodation, destination };
}

function deriveProfileFieldsFromOnboarding(ob) {
    const {
        familySize,
        accommodation,
        destination,
        // optional newer fields
        houseIntent: explicitHouseIntent,
        rentBudget: explicitRentBudget,
        adults: explicitAdults,
        children: explicitChildren,
    } = ob || {};

    // Normalize legacy
    const fsRaw = String(familySize || "").trim();
    const fs = fsRaw.replace(/–/g, "-").toLowerCase();

    const accRaw = String(accommodation || "").trim();
    const acc = accRaw.toLowerCase();

    // Adults/children (prefer explicit)
    let adults = Number.isFinite(explicitAdults) ? explicitAdults : 2;
    let children = Number.isFinite(explicitChildren) ? explicitChildren : 0;

    if (!Number.isFinite(explicitAdults)) {
        switch (fs) {
            case "just me": adults = 1; children = 0; break;
            case "couple": adults = 2; children = 0; break;
            case "3-5 people": adults = 2; children = 1; break;
            case "6+ people": adults = 2; children = 4; break;
            default: break;
        }
    }

    // House Intent (prefer explicit)
    let houseIntent = explicitHouseIntent || "Either";
    if (!explicitHouseIntent) {
        if (acc.includes("rent")) houseIntent = "Rent";
        if (acc.includes("buy")) houseIntent = "Buy";
    }

    // Budget (prefer explicit)
    function parseBudget(str) {
        const m1 = str.match(/budget\s*[:=]?\s*\$?\s*([\d,]+)\s*(k)?/i);
        const m2 = m1 || str.match(/\$?\s*([\d,]+)\s*(k)?/i);
        if (!m2) return null;
        let num = m2[1].replace(/,/g, "");
        let val = Number(num);
        if (Number.isNaN(val)) return null;
        if (m2[2]) val = val * 1000;
        return Math.max(2000, Math.min(8000, val));
    }
    const rentBudget = Number.isFinite(explicitRentBudget)
        ? explicitRentBudget
        : (parseBudget(accRaw) ?? 3500);

    return {
        destination: destination || "",
        adults,
        children,
        houseIntent,
        rentBudget,
        accommodation: accRaw,
        familySize: fsRaw,
    };
}



function toFamilySizeLabel(adults, children) {
    if (adults <= 1 && children === 0) return "Just me";
    if (adults === 2 && children === 0) return "Couple";
    if (adults + children >= 6) return "6+ people";
    return "3-5 people";
}

function toAccommodationString(houseIntent, rentBudget) {
    // Keeps compatibility with your parser in deriveProfileFieldsFromOnboarding
    // Example: "Rent, budget: $3500"
    const intent = houseIntent || "Either";
    const budgetPart = rentBudget ? `, budget: $${Number(rentBudget).toLocaleString()}` : "";
    return `${intent}${budgetPart}`;
}

export default function Profile() {
    const navigate = useNavigate()
    const [adults, setAdults] = useState(2);
    const [children, setChildren] = useState(0);
    const [rentBudget, setRentBudget] = useState(3500);
    const [commuteTime, setCommuteTime] = useState(30);
    const [houseIntent, setHouseIntent] = useState("Rent");
    const [accessibility, setAccessibility] = useState(false);
    const [petFriendly, setPetFriendly] = useState(false);
    const [keywords, setKeywords] = useState([
        "Quiet", "Lively", "Family-friendly", "Pet-friendly", "Green spaces",
    ]);
    const amenityList = ["Grocery store", "Hospital", "Library", "Good schools", "Restaurants"];
    const [selectedAmenities, setSelectedAmenities] = useState(new Set(["Grocery store"]))
    const [destination, setDestination] = useState("")
    const [workLocation, setWorkLocation] = useState("");
    const [targetMoveMonth, setTargetMoveMonth] = useState("");
    const [justSaved, setJustSaved] = useState(false)

    const toggleAmenity = (name) => {
        setSelectedAmenities((prev) => {
            const next = new Set(prev)
            next.has(name) ? next.delete(name) : next.add(name)
            return next
        })
    }

    useEffect(() => {
        const ob = readOnboardingPrefs();
        const derived = deriveProfileFieldsFromOnboarding(ob);
        console.log("Derived prefs ->", derived)

        // destination input
        setDestination(derived.destination);

        // map to existing fields only on first load
        setAdults(derived.adults);
        setChildren(derived.children);
        setHouseIntent(derived.houseIntent);
        setRentBudget(derived.rentBudget);

        setCommuteTime(Number.isFinite(ob.commuteTime) ? ob.commuteTime : 30);
        setAccessibility(!!ob.accessibility);
        setPetFriendly(!!ob.petFriendly);
        setKeywords(
            Array.isArray(ob.keywords)
                ? ob.keywords
                : ["Quiet", "Lively", "Family-friendly", "Pet-friendly", "Green spaces"]
        );
        setSelectedAmenities(
            new Set(
                Array.isArray(ob.selectedAmenities)
                    ? ob.selectedAmenities
                    : ["Grocery store"]
            )
        );
        setWorkLocation(ob.workLocation ?? "");
        setTargetMoveMonth(ob.targetMoveMonth ?? "");

    }, []); // run once

    const handleSave = () => {
        // Build compatible strings for your existing flow
        const familySizeLabel = toFamilySizeLabel(adults, children);
        const accommodationStr = toAccommodationString(houseIntent, rentBudget);

        // Merge with existing unified prefs (preserve initialQuery etc.)
        let unified = {};
        try {
            unified = JSON.parse(localStorage.getItem("onboarding_prefs") || "{}");
        } catch (_) { }

        const updated = {
            ...unified,
            destination: (destination || "").trim(),
            familySize: familySizeLabel,
            accommodation: accommodationStr,

            houseIntent,
            rentBudget,
            adults,
            children,
            commuteTime,
            accessibility,
            petFriendly,
            keywords,
            selectedAmenities: Array.from(selectedAmenities), // serialize Set
            workLocation: (workLocation || "").trim(),
            targetMoveMonth,

        };

        // Write unified object
        localStorage.setItem("onboarding_prefs", JSON.stringify(updated));

        // Backward-compat keys (your older code looks for these)
        localStorage.setItem("destination", updated.destination);
        localStorage.setItem("familySize", updated.familySize);
        localStorage.setItem("accommodation", updated.accommodation);

        // Tiny confirmation UI
        setJustSaved(true);
        setTimeout(() => setJustSaved(false), 1200);
    };

    return (
        <div style={styles.page}>
            {/* Header */}
            <div style={styles.headerWrap}>
                <div style={styles.headerRow}>
                    <button aria-label="Back" style={styles.backBtn} onClick={() => navigate("/home")}>
                        <img src={back} alt="Back" style={styles.backIcon} />
                    </button>

                    <h1 style={styles.title}>Profile</h1>

                    <button
                        aria-label="Save Profile"
                        style={styles.saveBtn}
                        onClick={handleSave}
                        onMouseDown={(e) => (e.currentTarget.style.opacity = "0.9")}
                        onMouseUp={(e) => (e.currentTarget.style.opacity = "1")}
                    >
                        {justSaved ? "Saved ✓" : "Save"}
                    </button>
                </div>
            </div>

            {/* Content */}
            <div style={styles.body}>
                {/* Essential Information */}
                <section style={styles.section}>
                    <div style={styles.sectionTitle}>Essential Information</div>

                    {/* Destination */}
                    <div style={{ marginBottom: 12 }}>
                        <label style={styles.fieldLabel}>Destination</label>
                        <div style={styles.inputRow}>
                            <input style={styles.textInput} placeholder="Location or zip code" value={destination} onChange={(e) => setDestination(e.target.value)} />
                            <img src={location} alt="Location" style={styles.trailingIcon} />
                        </div>
                    </div>

                    {/* Target Move Month */}
                    <div style={{ marginBottom: 12 }}>
                        <label style={styles.fieldLabel}>Target Move Month</label>
                        <div style={styles.inputRow}>
                            <select
                                style={{ ...styles.textInput }}
                                value={targetMoveMonth}
                                onChange={(e) => setTargetMoveMonth(e.target.value)}
                            >
                                <option value="">Select Month</option>
                                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
                                    <option key={m} value={m}>{m}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* House Intent (segmented) */}
                    <div style={{ marginBottom: 8 }}>
                        <label style={styles.fieldLabel}>House Intent</label>
                        <div style={styles.segmentRow}>
                            {["Rent", "Buy", "Either"].map((opt) => {
                                const active = houseIntent === opt;
                                return (
                                    <button
                                        type="button"
                                        key={opt}
                                        onClick={() => setHouseIntent(opt)}
                                        style={{ ...styles.segment, ...(active ? styles.segmentActive : {}) }}
                                    >
                                        {opt}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Monthly Rent Budget */}
                    <div>
                        <label style={styles.fieldLabel}>
                            Monthly Rent Budget
                            <span style={{ marginLeft: 8, color: "#6B7280" }}>
                                (${rentBudget.toLocaleString()})
                            </span>
                        </label>
                        <input
                            type="range"
                            min="2000"
                            max="8000"
                            step="50"
                            value={rentBudget}
                            onChange={(e) => setRentBudget(Number(e.target.value))}
                            style={styles.slider}
                        />
                        <div style={styles.scale}>
                            <span>$2,000</span>
                            <span>$5,000</span>
                            <span>$8,000+</span>
                        </div>
                    </div>
                </section>

                {/* Household & Family */}
                <section style={styles.section}>
                    <div style={styles.sectionTitle}>Household & Family</div>

                    <RowCounter
                        label="Adults"
                        value={adults}
                        onDec={() => setAdults(Math.max(1, adults - 1))}
                        onInc={() => setAdults(adults + 1)}
                    />

                    <RowCounter
                        label="Children"
                        value={children}
                        onDec={() => setChildren(Math.max(0, children - 1))}
                        onInc={() => setChildren(children + 1)}
                    />

                    <RowToggle label="Accessibility needs" checked={accessibility} onChange={setAccessibility} />
                    <RowToggle label="Pet friendly" checked={petFriendly} onChange={setPetFriendly} />
                </section>

                {/* Lifestyle & Commute */}
                <section style={styles.section}>
                    <div style={styles.sectionTitle}>Lifestyle & Commute</div>

                    {/* Work location */}
                    <div style={{ marginBottom: 12 }}>
                        <label style={styles.fieldLabel}>Work location</label>
                        <div style={styles.inputRow}>
                            <input style={styles.textInput} placeholder="Enter work address" value={workLocation} onChange={(e) => setWorkLocation(e.target.value)} />
                            <img src={location} alt="Location" style={styles.trailingIcon} />
                        </div>
                    </div>

                    {/* Commute time */}
                    <div>
                        <label style={styles.fieldLabel}>Maximum commute time</label>
                        <input
                            type="range"
                            min="15"
                            max="90"
                            step="15"
                            value={commuteTime}
                            onChange={(e) => setCommuteTime(Number(e.target.value))}
                            style={styles.slider}
                        />
                        <div style={styles.scale}>
                            <span>15 min</span><span>30 min</span><span>90+ min</span>
                        </div>
                    </div>
                </section>

                {/* Neighborhood Vibe */}
                <section style={styles.section}>
                    <div style={styles.sectionTitle}>Neighborhood Vibe</div>
                    <input
                        style={styles.chipInput}
                        placeholder="Input keywords (e.g. suburban, quiet)"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                const v = e.target.value.trim();
                                if (v && !keywords.includes(v)) setKeywords([...keywords, v]);
                                e.target.value = "";
                            }
                        }}
                    />
                    <div style={styles.chipWrap}>
                        {keywords.map((k) => (
                            <span key={k} style={styles.chip}>
                                {k}
                                <button style={styles.chipX} onClick={() => setKeywords(keywords.filter((w) => w !== k))}>×</button>
                            </span>
                        ))}
                    </div>
                </section>

                {/* Community & Amenities */}
                <section style={styles.section}>
                    <div style={styles.sectionTitle}>Community & Amenities</div>
                    <div style={styles.subLabel}>Important Amenities</div>

                    <div style={styles.amenitiesGrid}>
                        {amenityList.map((item) => {
                            const isSelected = selectedAmenities.has(item);
                            return (
                                <button
                                    key={item}
                                    type="button"
                                    onClick={() => toggleAmenity(item)}
                                    aria-pressed={isSelected}
                                    style={{
                                        ...styles.pillBtn,
                                        ...(isSelected ? styles.pillBtnSelected : {}),
                                    }}
                                >
                                    {item}
                                </button>
                            );
                        })}
                    </div>
                </section>

                <button style={styles.backToTop} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                    Back to top
                </button>
            </div>
        </div>
    );
}

/* ===== Helpers (inline styles) ===== */

function RowCounter({ label, value, onDec, onInc }) {
    const hoverStyle = { background: "var(--colors-blue-100, #DCEBFE)" };

    return (
        <div style={styles.rowCard}>
            <span>{label}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <button
                    aria-label={`decrease ${label}`}
                    style={styles.counterBtn}
                    onClick={onDec}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
                    onMouseLeave={(e) => e.currentTarget.style.background = ''}
                >
                    –
                </button>
                <span style={{ width: 24, textAlign: "center" }}>{value}</span>
                <button
                    aria-label={`increase ${label}`}
                    style={styles.counterBtn}
                    onClick={onInc}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
                    onMouseLeave={(e) => e.currentTarget.style.background = ''}
                >
                    +
                </button>
            </div>
        </div>
    );
}

function RowToggle({ label, checked, onChange }) {
    return (
        <div style={styles.rowCard}>
            <span>{label}</span>
            <button
                role="switch"
                aria-checked={checked}
                aria-label={label}
                onClick={() => onChange(!checked)}
                style={styles.toggleTrack(checked)}
            >
                <span style={styles.toggleThumb(checked)} />
            </button>
        </div>
    );
}

